// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .home-reporting-kpis__card[data-v-9738e4a4] {\n  border-radius: 0.5rem;\n}\n.home-reporting-kpis__toggle[data-v-9738e4a4] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n", ""]);
// Exports
module.exports = exports;
